import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarTopbar from "../../components/layouts/layout";

export default function PubVerse() {
  const navigate = useNavigate();

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const userRole = userData.Role || userData.role || "";
    if (userRole.toLowerCase() === "admin") {
      navigate("/dashboard", { replace: true });
    }

    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.1); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
      .coming-soon-badge {
        animation: pulse 2s infinite;
      }
      body {
        overflow: hidden;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <SidebarTopbar>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        backgroundColor: '#f5f5f5',
        overflow: 'hidden'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          padding: '2rem 1.5rem',  // Reduced padding
          maxWidth: '600px',
          width: '90%',  // Added width to ensure responsive design
          textAlign: 'center',
          position: 'relative'
        }}>
          <div className="coming-soon-badge" style={{
            position: 'absolute',
            top: '-15px',  // Reduced from -20px
            right: '-15px',  // Reduced from -20px
            background: 'linear-gradient(45deg, #1E4DE3, #5c7fed)',
            color: 'white',
            padding: '0.4rem 0.8rem',  // Reduced padding
            borderRadius: '20px',
            fontSize: '0.8rem',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            Coming Soon
          </div>

          <h1 style={{
            fontSize: '2.2rem',  // Reduced from 2.5rem
            fontWeight: 700,
            margin: '0 0 0.8rem',  // Reduced margin
            background: 'linear-gradient(45deg, #1E4DE3, #5c7fed)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            color: 'transparent'
          }}>
            PubVerse
          </h1>

          <p style={{
            color: '#666',
            fontSize: '1rem',  // Reduced from 1.1rem
            lineHeight: '1.5',  // Reduced from 1.6
            marginBottom: '1.5rem'  // Reduced from 2rem
          }}>
            Upload multiple publications and simply tell Pubverse what you need. Whether you want to compare two papers, summarize a complex study, or build a comprehensive deck, our tool handles the complexity for you.

            Just ask in the Pubverse chat, and it instantly generates motion graphic videos, editable PowerPoint presentations, scientific posters, or audio summaries. High-quality, professional assets—ready in minutes.
          </p>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '1rem'
          }}>
           

        
          </div>
        </div>
      </div>
    </SidebarTopbar>
  );
}